export default __webpack_public_path__ + "static/media/key-man.851ca353.svg";